import { axios } from './axios';

export const eventLogsApi = {
  async getRecentEventLogs() {
    return axios.get('event-logs');
  }
};
